import React from 'react';
import classNames from 'classnames';
import { Button } from '../Button';
import './styles.scss';


const ButtonPrimary = (props) => {
  let { className, ...otherProps } = props;
  className = classNames("ov-btn-primary", className);
  return (
      <Button className={className} {...otherProps} />
  );
}


ButtonPrimary.propTypes = Button.propTypes;
ButtonPrimary.defaultProps = Button.defaultProps;
export { ButtonPrimary };
